import VueI18n from "vue-i18n";

const i18n = new VueI18n({
  locale: window.localStorage.getItem("lang") ? window.localStorage.getItem("lang") : "CN",
  messages: {
    CN: require("../lang/CN.js"),
    EN: require("../lang/EN.js"),
    HK: require("../lang/HK.js"),
  },
});

console.log(i18n);
const dic = {
  DianWeiFa: i18n.t("lang.电位法"),
  DianWeiDiDingFa: i18n.t("lang.电位滴定法"),
  XiaoSuanYin: i18n.t("lang.硝酸银"),
  ShuiNi: i18n.t("lang.水泥"),
  WaiJiaJi: i18n.t("lang.外加剂"),
  KongBai: i18n.t("lang.空白"),
  LvHuaWu: i18n.t("lang.氯化物"),
  ShuiHuiBi: i18n.t("lang.水灰比"),
  BanHeWu: i18n.t("lang.拌合物"),
  ZhiLiangTiJi: i18n.t("lang.质量体积"),
};

export default dic;
